import {useCreatePortalSession} from "@tinct/core-api";
import {CustomerPortalSessionResponse} from "@tinct/core-api-models";
import {useLocation} from "react-router-dom";
import {useCurrentOrganization} from "@tinct/core-workspace";

export const useManageSubscription = () => {
  const location = useLocation();
  const currentOrganization = useCurrentOrganization();
  const { mutate: createPortalSession, isPending } = useCreatePortalSession({
    onSuccess: (data: CustomerPortalSessionResponse) => {
      if (data.url) {
        window.location.href = data.url;
      }
    },
  })

  const handleManageSubscription = () => {
    const baseUrl = window.location.origin;
    const currentPath = location.pathname;

    createPortalSession({
      returnUrl: `${baseUrl}${currentPath}`,
      organizationId: currentOrganization.id ?? '',
    })
  };

  return { handleManageSubscription, isPending };
}
